import React from 'react';
import Dashboard from '../../components/dashboard';
import Layout from '../layout';

const DashboardContainer = () => (
  <Layout>
    <Dashboard />
  </Layout>
);

export default DashboardContainer;
